const LOGO_URL_BY_COMPANY = {
  amicus: '/images/amicus-logo.png',
  buzzreach: '/images/buzzreach_logo.png',
  sparks: '/images/dsearch-logo_2.png',
};

export default function getLogoUrl() {
  return LOGO_URL_BY_COMPANY[process.env.REACT_APP_COMPANY] || '/images/dsearch-logo.png';
}
